import { createRouter, createWebHashHistory } from 'vue-router'
import { isRegionBlocked } from '../utils/geoLocation'

const routes = [
  {
    path: '/',
    name: 'zkAgent',
    meta: { title: 'zkAgent' },
    component: () => import('../views/home.vue')
  },
  {
    path: '/region-blocked',
    name: 'RegionBlocked',
    meta: { title: 'Region Restricted - zkAgent' },
    component: () => import('../views/region-blocked.vue')
  },
  {
    path: '/test-region',
    name: 'TestRegion',
    meta: { title: 'Region Detection Test - zkAgent' },
    component: () => import('../views/test-region.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// Route guard - Region check
router.beforeEach(async (to, from, next) => {
  // If accessing region blocked page or test page, allow directly
  if (to.name === 'RegionBlocked' || to.name === 'TestRegion') {
    next()
    return
  }
  
  try {
    // Check if user is from a blocked region
    const isBlocked = await isRegionBlocked()
    
    if (isBlocked) {
      // If blocked, redirect to region blocked page
      next({ name: 'RegionBlocked' })
    } else {
      // If not blocked, allow normal access
      next()
    }
  } catch (error) {
    console.error('Region check failed:', error)
    // If check fails, allow access by default (avoid false positives)
    next()
  }
})

export default router
